/* eslint-disable default-param-last */

export const modals = (state = [], action) => {
  switch (action.type) {
    case 'SHOW_MODAL': return [{ id: action.id, options: action.options, onClose: action.onClose }, ...state];
    case 'DESTROY_MODAL': return state.filter((m) => m.id !== action.id);
    default: return state;
  }
};
